import { Network } from '@kattana-io/common';
import { useDispatch, useSelector } from 'react-redux';
import { useAccount } from 'wagmi';
import { actionShowModal } from '../../../../actions/modal';
import FallbackImage from '../../../../atoms/Image/Fallback';
import Text from '../../../../atoms/Text';
import Loader from '../../../../components/common/Loader';
import { toFixed4 } from '../../../../components/DexTrades/formatters';
import { networks } from '../../../../components/NetworkSelector/core';
import NetworkSelector from '../../../../components/NetworkSelector';

import { formatAddress } from '../../../../helpers/formatters';
import { ModalTypes } from '../../../../reducers/modal';
import { useWallet } from '../../../../wallet/walletContext';
import { IStore } from '../../../../reducers';
import { networkSelector } from '../../../../selectors/network';

const getCoinName = (net: string) => {
  switch (net) {
  case 'optimism-mainnet':
    return 'OP';
  case 'fantom-mainnet':
    return 'FTM';
  default:
    return net;
  }
};

const FallbackCoinIcon = ({ name }: any) => {
  return <div className='token__fallback'>{name[0]}</div>;
};

const SidebarWallet = () => {
  const { address: account } = useAccount();
  const network = useSelector(networkSelector);
  const dispatch = useDispatch();
  const {
    state: { error, tokenBalancesBySym, loading },
    isConnecting,
  } = useWallet();

  /**
   * Call the modal for connecting new wallet
   */
  const onConnect = () => {
    dispatch(actionShowModal(ModalTypes.connect, {}));
  };

  /**
   * Change of address/chain effects
   */
  // useEffect(() => {
  //   if (chain?.id != network?.toDecimal()) {
  //     setNetwork(Network.fromChainId(chain.id));
  //   }
  // }, [chain]);

  if (account && network) {
    const cNet = network.toCovalentNetwork();

    const token = networks.find((el) => el.toDecimal() === network.toDecimal());

    return (
      <div className='global_sidebar_mobile__wallet_connected'>
        <div className='global_sidebar_mobile__wallet_connected__network'>
          <NetworkSelector textSize={16} imageSize='l' textWeight='500' />
        </div>

        <div className='global_sidebar_mobile__wallet_connected__divider' />

        {loading && <Loader />}
        {error && (
          <Text size={14} className='warning'>
            Could not fetch balance of your wallet
          </Text>
        )}

        {!loading && !error && (
          <div className='global_sidebar_mobile__wallet_connected__wallet_info'>
            <div className='global_sidebar_mobile__wallet_connected__wallet_info__item'>
              <Text size={12} className='text--grey-600 text--weight-500'>
                Balance
              </Text>
              <div className='global_sidebar_mobile__wallet_connected__wallet_info__item__balance'>
                <FallbackImage
                  size='s'
                  src={token?.getImage()}
                  fallback={<FallbackCoinIcon name={token?.chain} />}
                />
                <Text
                  size={16}
                  className='text--weight-500 text--grey-400 global_sidebar_mobile__wallet_connected__wallet_info__item__balance__coin'
                >
                  {toFixed4(Number(tokenBalancesBySym[cNet] || 0))}&nbsp;
                  {getCoinName(cNet)}
                </Text>
              </div>
            </div>
            <div className='global_sidebar_mobile__wallet_connected__wallet_info__item'>
              <Text size={12} className='text--grey-600 text--weight-500'>
                Wallet
              </Text>
              <Text size={16} className='text--weight-500 text--navy-600'>
                {formatAddress(account)}
              </Text>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className='global_sidebar_mobile__wallet_button' onClick={onConnect}>
      <Text size={16} className='text--weight-600 text--white'>
        {isConnecting ? 'Connecting' : 'Connect Wallet'}
      </Text>
    </div>
  );
};

export default SidebarWallet;
